import PageTabs from './PageTabs';
export default PageTabs;
